import {injectable} from "inversify";
import Scene = Phaser.Scene;
import {PlayerMarker} from "@/store/player/types";
import PlayerStore from "@/store/player";
import {Markers} from "@/constants/marker";
import {PaymentChangePanel} from "@/scenes.ui/payment-change-panel";
import {IntegrationUtils} from "@/utils/integration-utils";

@injectable()
export class PaymentChangeService {

    public async open(scene: Scene, canvas: HTMLCanvasElement) {
        new PaymentChangePanel(scene, canvas, this.isUseXsolla(),() => {
            PlayerStore.REMOVE_MARKER(Markers.USE_XSOLLA_MARKER);
            PlayerStore.removeMarker(Markers.USE_XSOLLA_MARKER);
            PlayerStore.SET_MARKER(Markers.USE_ROBOKASSA_MARKER);
            PlayerStore.setMarker(Markers.USE_ROBOKASSA_MARKER);
        }, () => {
            PlayerStore.REMOVE_MARKER(Markers.USE_ROBOKASSA_MARKER);
            PlayerStore.removeMarker(Markers.USE_ROBOKASSA_MARKER);
            PlayerStore.SET_MARKER(Markers.USE_XSOLLA_MARKER);
            PlayerStore.setMarker(Markers.USE_XSOLLA_MARKER);
        }).open();
    }

    public isUseXsolla(): Boolean {
        return this.haveMarker(Markers.USE_XSOLLA_MARKER) || IntegrationUtils.isEnglishServer();
    }

    private haveMarker(marker: String): Boolean {
        return PlayerStore.getPlayer()!.playerMarkers.some((m: PlayerMarker) => m.playerMarker == marker);
    }
}
